import { useSelector } from 'react-redux';

export const useLang = () => useSelector(({ lang }) => lang);
